module.exports = __webpack_public_path__ + "img/SB_19.7fc7d33f.png";